import React, { Component } from 'react';
import { Route } from 'react-router-dom';

import Settings from './Settings';

class Container extends Component {
  render() {
    return (
      <div id="settings">
        <Route exact path="/settings" component={Settings} />
      </div>
    );
  }
}

export default Container;
